import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { WhatsNewNotificationItemDto } from "@models";
import { HttpErrorHandlerService } from '@services/webapi/http-error-handler.service';
import { catchError, Observable, of } from 'rxjs';
import { environment } from '@environments';
import { Params } from '@angular/router';
import { DataResponse } from '@models/grid.models';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  readonly #http = inject(HttpClient);
  readonly #httpErrorHandler = inject(HttpErrorHandlerService);
  readonly #webApiUrl = environment.apiConfig.baseUrl;
  private static readonly WHATSNEW_NOTICE_ENDPOINT = '/Notifications';
  private static readonly DEFAULT_PARAMS = {
    pageSize: 10,
    pageNumber: 1,
    sortExpression: 'publishedOn Desc',
    search: null,
    filterGroups: null
  };
  public getNotifications(params? : Params): Observable<DataResponse<WhatsNewNotificationItemDto>>{
    const url = `${this.#webApiUrl}${NotificationService.WHATSNEW_NOTICE_ENDPOINT}`;
    return this.#http.post<DataResponse<WhatsNewNotificationItemDto>>(
      url,
      this.buildRequestParams(params)
    ).pipe(
      catchError((error: unknown) => {
        this.#httpErrorHandler.handleError(error);
        return of({
          items: [],
          currentPage: 1,
          pageSize: 10,
          totalCount: 0
        });
      })
    );
  }
  /**
   * Builds request parameters by merging defaults with provided params.
   * @param params Optional query parameters.
   * @returns Merged request parameters.
   */
  private buildRequestParams(params?: Params): Params {
    return {
      pageSize:
        params?.['pageSize'] ||
        NotificationService.DEFAULT_PARAMS.pageSize,
      pageNumber:
        params?.['pageNumber'] ||
        NotificationService.DEFAULT_PARAMS.pageNumber,
      sortExpression:
        params?.['sortExpression'] ||
        NotificationService.DEFAULT_PARAMS.sortExpression,
      search:
        params?.['search'] ||
        NotificationService.DEFAULT_PARAMS.search,
      filterGroups:
        params?.['filterGroups'] ||
        NotificationService.DEFAULT_PARAMS.filterGroups,
    };
  }
}
